import firebase from 'firebase/app';
import 'firebase/messaging'
import 'firebase/remote-config'

const firebaseConfig = {
    apiKey: "AIzaSyBOvw1E4A5WGT2dgRekma7bjLNozF2T7Q4",
    authDomain: "vaccine-notify.firebaseapp.com",
    projectId: "vaccine-notify",
    storageBucket: "vaccine-notify.appspot.com",
    messagingSenderId: "457736642036",
    appId: "1:457736642036:web:909de72c3826dce352eda1"
};

var messaging=null;
//   firebase.initializeApp(firebaseConfig);
var config = firebase.initializeApp(firebaseConfig);
if (firebase.messaging.isSupported()) {
     messaging = config.messaging();
} else {
     messaging = '';
}
const remoteConfig=firebase.remoteConfig();


remoteConfig.settings = {
    minimumFetchIntervalMillis: 30
  };

  remoteConfig.defaultConfig = ({
    'age_groups':[18,40,45]
 });


export {messaging,remoteConfig};